<template>
  <div>
    <v-text-field label="Discount Percentage" type="number" :value="percent" suffix="%" outlined dense hide-details
      @input="percentChange" />
  </div>
</template>

<script>
export default {
  name: 'PctDisc',
  props: {
    percent: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    /**
     * @param {InputEvent} e
     */
    percentChange(val) {
      this.$emit('update:percent', val)
    },
  },
}
</script>